var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-menu',{attrs:{"value":_vm.visible,"position-x":_vm.dialogX,"position-y":_vm.dialogY,"absolute":"","offset-y":""},on:{"input":function($event){return _vm.emitInput($event)}}},[_c('v-card',[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }